import 'react-app-polyfill/ie11'; // This must be the first line
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);
